export interface DurationConstraints {
    min: string | null;
    max: string | null;
}

export class DurationInputService {
    private static readonly CONSTRAINTS: Record<string, DurationConstraints> = {
      'OPTION.SYSTEM.SOFTWARE.MESSAGING.DEFAULT_LOCATION_INTERVAL': {
        min: '00:00:00',
        max: '01:00:00'
      },
      'OPTION.SYSTEM.SOFTWARE.MESSAGING.DEFAULT_HEARTBEAT_INTERVAL': {
        min: '00:00:00',
        max: '01:00:00'
      },
      'OPTION.SYSTEM.SOFTWARE.LOGGING.LOGGING_REPORT_INTERVAL': {
        min: '00:00:05',
        max: '00:05:00'
      },
      'OPTION.APPLICATION.ALERTS.RED_ALERT.RED_ALERT_BUTTON_PRESS_DURATION': {
        min: '00:00:02',
        max: '00:00:10'
      },
      'OPTION.APPLICATION.ALERTS.RED_ALERT.RED_ALERT_CALL_DURATION': {
        min: '00:15:00',
        max: '01:30:00'
      },
      'OPTION.APPLICATION.ALERTS.RED_ALERT.RED_ALERT_LOCATION_INTERVAL': {
        min: '00:00:30',
        max: '00:05:00'
      },
      'OPTION.APPLICATION.ALERTS.RED_ALERT.RED_ALERT_RETRY_INTERVAL': {
        min: '00:00:10',
        max: '00:01:00'
      },
      'OPTION.APPLICATION.ALERTS.CHECK_IN_ALERT.CHECK_IN_ALERT_BUTTON_PRESS_DURATION': {
        min: '00:00:02',
        max: '00:00:10'
      },
      'OPTION.APPLICATION.ALERTS.CHECK_IN_ALERT.CHECK_IN_ALERT_CALL_DURATION': {
        min: '00:00:10',
        max: '00:01:00'
      },
      'OPTION.APPLICATION.ALERTS.CHECK_IN_ALERT.CHECK_IN_ALERT_LOCATION_INTERVAL': {
        min: '00:00:10',
        max: '00:00:30'
      },
      'OPTION.APPLICATION.ALERTS.CHECK_IN_ALERT.CHECK_IN_ALERT_RETRY_INTERVAL': {
        min: '00:00:10',
        max: '00:01:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_CALL_DURATION': {
        min: '00:15:00',
        max: '01:30:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_LOCATION_INTERVAL': {
        min: '00:00:30',
        max: '00:05:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_RETRY_INTERVAL': {
        min: '00:00:10',
        max: '00:01:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_PREALERT_TIMER_DURATION': {
        min: '00:00:30',
        max: '00:04:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_PREALERT_TONE_INTERVAL': {
        min: '00:00:03',
        max: '00:00:10'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_TIMER_DURATION': {
        min: '00:15:00',
        max: '12:00:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_TIMER_MAXIMUM_VALUE': {
        min: '06:00:00',
        max: '12:00:00'
      },
      'OPTION.APPLICATION.ALERTS.INCAPACITATION_ALERT.INCAPACITATION_ALERT_TIMER_STEP_SIZE': {
        min: '00:05:00',
        max: '00:30:00'
      },
    };
  
    static getConstraints(key: string): DurationConstraints {
        const config = this.CONSTRAINTS[key];
        return {
          min: config?.min ?? null,
          max: config?.max ?? null
        };
    }
  
    static toSeconds(value: string): number {
      const [h, m, s] = value.split(':').map(v => parseInt(v, 10) || 0);
      return (h * 3600) + (m * 60) + s;
    }
  }